export enum CommissionsOutputReport {
  ALL = "ALL",
  PAID = "PAID",
  UNPAID = "UNPAID",
}
